/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBGENDER = {
    Female: 'F',
    Male: 'M'
} as const;
export type GHUBGENDER = typeof GHUBGENDER[keyof typeof GHUBGENDER];


export function GHUBGENDERFromJSON(json: any): GHUBGENDER {
    return GHUBGENDERFromJSONTyped(json, false);
}

export function GHUBGENDERFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBGENDER {
    return json as GHUBGENDER;
}

export function GHUBGENDERToJSON(value?: GHUBGENDER | null): any {
    return value as any;
}

